
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { BetAreaViewMixin } from '@/components/desk/betview/bet-area-mixin'
import { BET_TYPE } from '@/utils/constants'

@Options({})
export default class MultiBetArea extends Mixins(BetAreaViewMixin) {
    get multicolor(): string {
        let result = ''
        switch (this.betType) {
            case BET_TYPE.BANKER:
            case BET_TYPE.TIGER:
            case BET_TYPE.BANKER_PAIR:
            case BET_TYPE.BANKER_SUPER6:
            case BET_TYPE.DRAGON_7:
                result = 'red'
                break
            case BET_TYPE.PLAYER:
            case BET_TYPE.DRAGON:
            case BET_TYPE.PLAYER_PAIR:
            case BET_TYPE.BEAR_8:
                result = 'blue'
                break
            case BET_TYPE.BC_TIE:
            case BET_TYPE.DT_TIE:
                result = 'green'
                break
            case BET_TYPE.SUPER6:
            case BET_TYPE.SMALL_TIGER:
            case BET_TYPE.BIG_TIGER:
                result = 'super6'
                break
        }

        if (!this.allowBet) {
            return result + '-blur'
        }
        return result
    }
}
